export default __webpack_public_path__ + "static/media/atmosphere.2149c5f0.svg";